import LegalPageLayout, {
  LegalList,
  LegalSection,
} from '../../components/feature/LegalPageLayout';
import {
  getLegalMissingFields,
  LEGAL_ADDRESS,
  LEGAL_BUSINESS_NAME,
  LEGAL_DIC,
  LEGAL_EMAIL,
  LEGAL_ICO,
  LEGAL_PHONE,
  LEGAL_REGISTER_ENTRY,
  LEGAL_SITE_NAME,
  LEGAL_SITE_URL,
  LEGAL_UPDATED_AT,
} from '../../lib/legalInfo';

export default function LegalInfoPage() {
  const missingFields = getLegalMissingFields();

  return (
    <LegalPageLayout
      badge="Právne informácie"
      badgeIcon="ri-file-list-3-line"
      title="Právne informácie"
      lead="Táto stránka obsahuje identifikačné a základné právne údaje o prevádzkovateľovi webu a o charaktere služieb, ktoré sú na stránke prezentované."
      supporting="Dokument slúži ako právny a identifikačný základ pre návštevníkov webu a obchodných partnerov."
      lastUpdated={LEGAL_UPDATED_AT}
    >
      {missingFields.length ? (
        <LegalSection title="Údaje na doplnenie pred finálnym zverejnením">
          <p>
            Pre úplnú právnu identifikáciu na verejne prístupnom webe je ešte
            potrebné doplniť tieto údaje:
          </p>
          <LegalList items={missingFields} />
        </LegalSection>
      ) : null}

      <LegalSection title="1. Poskytovateľ a prevádzkovateľ webu">
        <p>
          Prevádzkovateľom a poskytovateľom služieb informačnej spoločnosti na
          tejto webovej stránke je <strong>{LEGAL_SITE_NAME}</strong>, názov živnosti{' '}
          <strong>{LEGAL_BUSINESS_NAME}</strong>.
        </p>
        <LegalList
          items={[
            `webové sídlo: ${LEGAL_SITE_URL}`,
            `e-mail: ${LEGAL_EMAIL}`,
            `telefón: ${LEGAL_PHONE}`,
            `IČO: ${LEGAL_ICO}`,
            `DIČ: ${LEGAL_DIC}`,
            LEGAL_ADDRESS
              ? `miesto podnikania: ${LEGAL_ADDRESS}`
              : 'miesto podnikania: údaj bude doplnený po overení',
            LEGAL_REGISTER_ENTRY
              ? `zápis v registri: ${LEGAL_REGISTER_ENTRY}`
              : 'zápis v registri: údaj bude doplnený po overení',
          ]}
        />
      </LegalSection>

      <LegalSection title="2. Charakter webu a ponúkaných služieb">
        <p>
          Web slúži najmä ako prezentačná a kontaktná stránka freelancera /
          digitálneho konzultanta. Cez web je možné získať informácie o službách,
          orientačných cenách, ukážkach projektov a odoslať dopyt.
        </p>
        <p>
          Samotný web neslúži ako e-shop ani ako automatizovaná platforma na
          uzatváranie spotrebiteľských zmlúv bez individuálnej komunikácie. Konkrétna
          spolupráca, rozsah služieb, termíny a cena sa riešia individuálne.
        </p>
      </LegalSection>

      <LegalSection title="3. Duševné vlastníctvo a obsah webu">
        <p>
          Obsah webu, texty, grafické prvky, fotografie, ukážky prác, zdrojová
          štruktúra a ďalšie autorské prvky sú chránené podľa príslušných právnych
          predpisov. Bez predchádzajúceho súhlasu nie je dovolené ich kopírovanie,
          šírenie ani komerčné použitie nad rámec zákonných výnimiek.
        </p>
        <p>
          Ochrana sa nevzťahuje na prvky, pri ktorých je z kontextu zrejmé, že ide
          o obsah tretích strán, klientské značky alebo odkazy na verejne dostupné
          projekty. V takých prípadoch zostávajú práva príslušným vlastníkom.
        </p>
      </LegalSection>

      <LegalSection title="4. Odkazy na tretie strany">
        <p>
          Na webe sa môžu nachádzať odkazy na externé stránky, sociálne siete alebo
          služby tretích strán. Za obsah, dostupnosť a podmienky týchto stránok
          nenesiem zodpovednosť v rozsahu, v akom ich nemôžem priamo ovplyvniť.
        </p>
      </LegalSection>

      <LegalSection title="5. Kontakt a vybavovanie podnetov">
        <p>
          Ak potrebujete doplňujúce právne alebo identifikačné informácie, prípadne
          máte podnet k obsahu webu, môžete ma kontaktovať na e-mailovej adrese{' '}
          <strong>{LEGAL_EMAIL}</strong>.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
